import { TransformTag } from '@/utils'

export default function({ flatfinders = [] }) {
  const get = (path, source = 'Root.item.posts') => {
    const slug = this.$path('_props.slug', this)
    if (!slug) return

    let data = this.$path(source, this.$store.state) || []
    if (source.includes('posts')) {
      data = data.find(p => p.slug === slug)
      if (!data) return
    }

    return this.$path(path, data)
  }

  return [
    {
      condition: get('media.cover.length') || get('content'),
      component: 'Section',
      props: {
        width: 'medium',
        id: 'section-info',
        class: 'section-info',
        style: 'font-size: 1.25rem;',
      },
      blocks: {
        default: [
          {
            component: 'Grid',
            props: {
              gap: '3rem',
              columns: '1',
            },
            blocks: {
              default: [
                {
                  component: 'Slider',
                  data: get('media.cover'),
                  condition: get('media.cover.length'),
                },
                {
                  component: 'Text',
                  props: { 'text-align': 'center', style: 'max-width: 620px; margin:0 auto' },
                  data: {
                    content: TransformTag(get('content')),
                  },
                  condition: get('content'),
                },
              ],
            },
          },
        ],
      },
    },

    {
      component: 'Section',
      condition: get('customFields.flatfinder.display') && flatfinders.length,
      blocks: {
        default: [
          {
            component: 'Flatfinder',
            data: {
              flatfinders,
            },
          },
          {
            component: 'Residentials',
            data: {
              project: get('id', 'Root.item'),
            },
          },
        ],
      },
    },

    {
      component: 'Section',
      condition: get('address.location.coordinates', 'Root.item') && this.options.displayTravelCalc,
      props: {
        width: 'small',
        class: 'travel-calc',
      },
      blocks: {
        default: [
          {
            component: 'TravelCalculator',
            props: {
              buttonOptions: {
                theme: 'secondary',
              },
            },
            data: {
              coordinates: get('address.location.coordinates', 'Root.item'),
            },
          },
        ],
      },
    },

    {
      condition:
        get('customFields.additional-sections.0.image.url') ||
        get('customFields.additional-sections.0.description'),
      component: 'Section',
      props: {
        width: 'medium',
        id: 'section-image-text',
        class: 'section-image-text',
      },
      blocks: {
        default: [
          {
            component: 'ImageText',
            data: {
              content: get('customFields.additional-sections'),
            },
          },
        ],
      },
    },
    {
      component: 'Section',
      props: {
        width: 'full',
        id: 'section-map',
        class: 'section-map',
        style: 'padding-bottom:0;',
      },
      blocks: {
        default: [
          {
            component: 'ScrollAnchor',
            data: 'map',
          },
          {
            component: 'Map',
            props: {
              aspectRatio: '21/9',
            },
            data: {
              ...get('address', 'Root.item'),
            },
          },
        ],
      },
      condition: get('customFields.page-settings.display-map'),
    },

    {
      component: 'Section',
      props: {
        width: 'medium',
        id: 'section-contact',
        class: 'section-contact',
        style: 'background-color: var(--light-grey);',
      },
      blocks: {
        default: [
          {
            component: 'ScrollAnchor',
            data: 'lead',
          },
          {
            component: 'Grid',
            props: {
              gap: '2rem 8rem',
              columns: '1:2',
            },
            blocks: {
              default: [
                {
                  component: 'Roles',
                  props: {},
                  data: {
                    content: get('roles.salesman', 'Root.item'),
                  },
                },

                {
                  component: 'Lead',
                  props: {
                    options: {
                      placeholders: {
                        'contact.name': this.$t('name'),
                        'contact.email': this.$t('email'),
                        'contact.phone': this.$t('phone'),
                        comment: this.$tc('message', 1),
                      },
                      fields: ['!title', '!contact.upsell'],
                      actionLabel: this.$t('send'),
                    },
                  },
                  data: {
                    reference: { onModel: 'Project', ref: get('id', 'Root.item') },
                  },
                  blocks: {
                    top: [
                      {
                        component: 'Text',
                        data: {
                          content: get('customFields.lead-top-content', 'Root.item'),
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ]
}
